import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ElementRef
} from "@angular/core";
import { ModalService } from "../../../utilities/modal/modal.service";
import { TwoFactorAuthService } from "../two-factor-auth.service";
import { ITwoFactorModel } from "../twoFactorModel";
@Component({
  selector: "prompt-modal",
  templateUrl: "./prompt-modal.component.html",
  styleUrls: ["./prompt-modal.component.scss"]
})
export class PromptModalComponent implements OnInit {
  @Input() modalId: string;
  @Input() contract: any;
  @Input() promptModalTitle: string;
  @Input() promptModalMsg: string;
  payloadData: ITwoFactorModel;
  @ViewChild("errorDiv") errorDiv: ElementRef;
  constructor(
    private modalService: ModalService,
    public twoFactorAuthService: TwoFactorAuthService
  ) {}
  ngOnInit() {
    this.twoFactorAuthService.loading = true;
    this.twoFactorAuthService.getTwoFactorStatus().subscribe(
      resp => {
        this.payloadData = this.twoFactorAuthService.getPayLoadData();
        if (
          this.payloadData.hrtContactStatus === "" &&
          this.payloadData.hrtContactValue === ""
        ) {
          this.twoFactorAuthService.serviceFail =
            "There was an error processing your request.Please try again later.";
        }
        this.twoFactorAuthService.loading = false;
      },
      error => {
        this.twoFactorAuthService.loading = false;
        this.twoFactorAuthService.serviceFail =
          "There was an error processing your request.Please try again later.";
      }
    );
    // this.payloadData = this.twoFactorAuthService.getPayLoadData();
    // console.log("prompt modal", this.modalId, this.contract);
  }

  close(event?: any) {
    this.contract = null;
    this.twoFactorAuthService.error = [];
    this.twoFactorAuthService.serviceFail = null;
    this.modalService.close(this.modalId);
    this.twoFactorAuthService.loading = true;
  }

  continueToNavigate() {
    this.twoFactorAuthService.loading = true;
    this.twoFactorAuthService.verifyCode = true;
  //   this.twoFactorAuthService.sendOneTimeCode("StepUp").subscribe(
  //     data => {
  //       if (data) {
  //         this.twoFactorAuthService.verifyCode = true;
  //         //this.verifyCodeFormGroup.reset();
  //       } else {
  //         this.twoFactorAuthService.serviceFail = "Cannot request a code at this time. Please try again later";
  //         this.twoFactorAuthService.verifyCode = false;
  //       }
  //       this.twoFactorAuthService.loading = false;
  //     },
  //     error => {
  //       this.twoFactorAuthService.verifyCode = false;
  //       this.twoFactorAuthService.loading = false;
  //       this.twoFactorAuthService.serviceFail = "Cannot request a code at this time. Please try again later";
  //     }
  //   );
   }
}
